// extracted by mini-css-extract-plugin
module.exports = {"comparisonChartContainer":"styles_comparisonChartContainer__BVYc3","tabs":"styles_tabs__o05pv"};